"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var VotedOnBehalf_1 = __importDefault(require("../../../Icons/Notifications/VotedOnBehalf"));
var i18N = {
    en: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "See if their vote is aligned"),
            "with your vision. You can always override their decision by voting on your own.")); },
        title: function (proposalTitle) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Your delegate voted on the proposal \"",
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, proposalTitle),
            "\"")); }
    },
    es: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "Verifica si su voto est\u00E1 alineado"),
            "con tu visi\u00F3n. Siempre puedes anular su decisi\u00F3n votando por tu cuenta.")); },
        title: function (proposalTitle) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Tu delegado vot\u00F3 en la propuesta \"",
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, proposalTitle),
            "\"")); }
    },
    zh: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "\u67E5\u770B\u4ED6\u4EEC\u7684\u6295\u7968\u662F\u5426\u7B26\u5408\u60A8\u7684\u613F\u666F\u3002"),
            "\u60A8\u59CB\u7EC8\u53EF\u4EE5\u901A\u8FC7\u81EA\u5DF1\u6295\u7968\u6765\u63A8\u7FFB\u4ED6\u4EEC\u7684\u51B3\u5B9A\u3002")); },
        title: function (proposalTitle) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u60A8\u7684\u59D4\u6258\u4EBA\u5728\u63D0\u6848\"",
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, proposalTitle),
            "\"\u4E0A\u6295\u4E86\u7968")); }
    }
};
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
var GovernanceVotedOnBehalfNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(VotedOnBehalf_1.default, null) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title(notification.metadata.proposalTitle)),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata.link))));
};
exports.default = GovernanceVotedOnBehalfNotification;
